export const dateToAwsDate = (date) => {
    const nd = new Date(date);
    const month = nd.getMonth() < 10 ? '0'+ (nd.getMonth()+1) : (nd.getMonth()+1);
    const day = nd.getDate() < 10 ? '0'+nd.getDate() : nd.getDate();
    return `${nd.getFullYear()}-${month}-${day}`
}